/**
 * Quien tiene sesión pero no puede entrar en su empresa activa: la empresa está
 * cerrada (`OD-0020` E-05) o su acceso se desactivó al pasar a Free
 * (`TDS-FREE-DOWNGRADE` E-01 §2).
 *
 * Antes caía en «Crea tu organización», que es falso para los dos: ya
 * pertenecen a una, y crear otra devolvía 409. Aquí se dice el motivo con el
 * texto de la API y, si está en otras empresas, se ofrece irse a una
 * (`OD-0060` D-04).
 */
import { useState } from "react";
import { api } from "../api/cliente";
import { t } from "../i18n/es";
import { Aviso, Boton, Tarjeta } from "../ui/primitivas";
import { SelectorDeEmpresa } from "./SelectorDeEmpresa";

export function PantallaSinAcceso({
  mensaje,
  accion,
  onCambiada,
  onSalir,
}: {
  mensaje: string;
  accion: string | null;
  onCambiada: () => void;
  onSalir: () => void;
}) {
  const [saliendo, setSaliendo] = useState(false);

  async function salir(): Promise<void> {
    setSaliendo(true);
    await api.logout();
    setSaliendo(false);
    onSalir();
  }

  return (
    <Tarjeta titulo={t.sinAcceso.titulo}>
      <Aviso tono="aviso">{mensaje}</Aviso>
      {accion !== null ? <p className="ayuda-neutra">{accion}</p> : null}
      <SelectorDeEmpresa id="sin-acceso" onCambiada={onCambiada} onSesionCaducada={onSalir} />
      <Boton variante="secundario" onClick={() => void salir()} deshabilitado={saliendo}>
        {saliendo ? t.cuenta.saliendo : t.cuenta.salir}
      </Boton>
    </Tarjeta>
  );
}
